import { CompanyUser_B_BASE, ICompanyUser_B_Field, ICompanyUser_B_Key } from './base/CompanyUser_B.base';
import {Injectable} from '@angular/core';
import {ReadonlyPersistentService, AgaveService, CadmoBetweenRange, CadmoOperator} from 'tq-agave';
import {CompanyUser} from './CompanyUser'



export class CompanyUser_B extends CompanyUser_B_BASE {
    // i fields servono per cose come la cadmo-table e cadmo-form-field
    // Nelle nuove versioni di typescript vengono ereditati anche i campi statici
    // static fieldList = CompanyUser_B_BASE.fieldList;
    // static keyList: string[] = CompanyUser_B_BASE.keyList;
    // static updateFieldList: string[] = CompanyUser_B_BASE.updateFieldList;

    constructor(value?: any) { super(value); }

    between_created_on_utc?: CadmoBetweenRange;
    between_modified_on_utc?: CadmoBetweenRange;
    override getCadmoOperators(): any {
        const operators = super.getCadmoOperators();
        // Metti qui sotto gli operatori custom
        if (this.between_created_on_utc?.start || this.between_created_on_utc?.stop) {
            operators['_operator_created_on_utc'] = CadmoOperator.BETWEEN;
            const {start, stop} = this.between_created_on_utc;
            operators['_startvalue_created_on_utc'] = start ? '' + AgaveService.getEpochFromDate(start) : undefined;
            operators['_stopvalue_created_on_utc'] = stop ? '' + AgaveService.getEpochFromDate(stop) : undefined;
        }
        if (this.between_modified_on_utc?.start || this.between_modified_on_utc?.stop) {
            operators['_operator_modified_on_utc'] = CadmoOperator.BETWEEN;
            const {start, stop} = this.between_modified_on_utc;
            operators['_startvalue_modified_on_utc'] = start ? '' + AgaveService.getEpochFromDate(start) : undefined;
            operators['_stopvalue_modified_on_utc'] = stop ? '' + AgaveService.getEpochFromDate(stop) : undefined;
        }
        return operators;
    }

    toPersistentA(): CompanyUser {
        return new CompanyUser(this);
    }

}

export type ICompanyUser_B = CompanyUser_B & ICompanyUser_B_Field;

// Nota bene: se si tratta di una vista che ha una chiave primaria, puoi anche sostituire le interfacce nel generic con dei tipi piu' consoni
@Injectable({ providedIn: 'root' })
export class CompanyUser_B_Service extends ReadonlyPersistentService<CompanyUser_B, ICompanyUser_B_Field, ICompanyUser_B_Key> {
    constructor(agaveService: AgaveService) { super(CompanyUser_B, agaveService); }
}

